/* tslint:disable:variable-name */
import { Injectable, Inject } from '@angular/core';
import { ISchema, BasePersistentApiClient, IParam } from '../common/index';
import {
    DataProviderBelongsToRelationships, DataProviderHasManyRelationships, IDataProvider,
    IDataProviderClient
} from './interfaces';
import {
    instanceCodeClientT, IInstanceCodeClient,
    paramsBuilderT, IParamsBuilder, IRecursiveArray
} from '../common/interfaces';
import { Field, BaseEntity, BelongsTo } from '../common/meta';
import { Country } from '../country/country.entity';
import { Advertiser } from '../advertiser/advertiser.entity';
import { INote, INoteable, INoteCollection } from '../note/interfaces';
import { IChangeable, IChangeCollection } from '../change/interfaces';
import { Observable } from 'rxjs/internal/Observable';
import { IComment, IPersistentComment } from '../comment/interfaces';
import { Archivable } from '../common/archivable/archivable';
import { BulkRemovable } from '../common/bulk-removable/bulk-removable';
import { IBulkResponse } from './../common/errors';
import { Changeable } from '../common/changeable/changeable';
import { Noteable } from '../common/noteable/noteable';
import { AuthHttp } from '../authentication/authentication.service';

export class DataProvider extends BaseEntity<IDataProvider> implements IDataProvider {

    public static readonly type: string = 'data_provider';

    @Field()
    id: string;

    @Field()
    name: string;

    @Field()
    address: string;

    @Field()
    postal_code: string;

    @Field()
    city: string;

    @Field()
    use_business_address_for_billing: boolean;

    @Field()
    email: string;

    @Field()
    phone: string;

    @Field()
    mobile: string;

    @Field()
    fax: string;

    @BelongsTo({ deferredConstructor: () => Country })
    country: Country;

    @BelongsTo({ deferredConstructor: () => Advertiser })
    advertiser: Advertiser;
}

@Injectable()
@Archivable()
@Changeable()
@BulkRemovable()
@Noteable()
export class DataProviderClient extends BasePersistentApiClient<IDataProvider, DataProviderBelongsToRelationships, DataProviderHasManyRelationships>
    implements IDataProviderClient, INoteable, IChangeable {
    protected static classConfig: ISchema = {
        apiResourceName: 'data_providers'
    };

    archive: (id: string) => Observable<IDataProvider>;
    unarchive: (id: string) => Observable<IDataProvider>;
    bulkRemove: (ids: string[]) => Observable<IBulkResponse[]>;

    constructor(
        http: AuthHttp,
        @Inject(instanceCodeClientT) instanceCodeClient: IInstanceCodeClient,
        @Inject(paramsBuilderT) paramsBuilder: IParamsBuilder
    ) {
        super(http, instanceCodeClient, paramsBuilder);
    }

    protected implementationClass() {
        return DataProvider;
    }

    getChanges(
        changeableId: string, params?: IParam, include?: IRecursiveArray<string>
    ): Observable<IChangeCollection> {
        throw new Error('Method not implemented.');
    }

    addChangeComment(note: IPersistentComment, changeableId: string): Observable<IComment> {
        throw new Error('Method not implemented.');
    }

    getNotes(noteableId: string, params?: IParam, include?: IRecursiveArray<string>): Observable<INoteCollection> {
        throw new Error('Method not implemented.');
    }

    addNote(note: INote): Observable<INote> {
        throw new Error('Method not implemented.');
    }

    addNoteComment(note: IPersistentComment): Observable<IComment> {
        throw new Error('Method not implemented.');
    }
}
